import React, { useState, useRef, useEffect } from "react";
import { Email, Phone, Badge, Shuffle, ExpandMore } from "@mui/icons-material";
import UseCadastroUsuario from "../../hooks/UseCadastroUsuario/UseCadastroUsuario";

export default function Cadastro() {
  const [openPix, setOpenPix] = useState(false);
  const pixRef = useRef(null);

  const tiposPix = [
    { label: "Email", icon: <Email fontSize="small" /> },
    { label: "Telefone", icon: <Phone fontSize="small" /> },
    { label: "CPF/CNPJ", icon: <Badge fontSize="small" /> },
    { label: "Chave aleatória", icon: <Shuffle fontSize="small" /> },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pixRef.current && !pixRef.current.contains(e.target)) {
        setOpenPix(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const {
    form,
    fieldErrors,
    loading,
    fileName,
    filePreview,
    fileInputRef,
    handleChange,
    handleCpfChange,
    handleDateChange,
    handlePhoneChange,
    handleFileChange,
    openFilePicker,
    handleSubmit,
    validateField,
    modalError,
    modalSuccess,
    setModalError,
    setModalSuccess,
    isSocialCadastro,
  } = UseCadastroUsuario();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !loading) {
        e.preventDefault();
        handleSubmit(e);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [loading, handleSubmit]);

  return (
    <>
      {(modalError || modalSuccess) && (
        <div
          className="modalOverlay"
          onClick={() => {
            setModalError("");
            setModalSuccess("");
          }}
        >
          <div className="modalBox" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="modalClose"
              onClick={() => {
                setModalError("");
                setModalSuccess("");
              }}
            >
              ×
            </button>

            <div className={`modalIcon ${modalError ? "error" : "success"}`}>
              {modalError ? "!" : "✓"}
            </div>

            <h3 className="modalTitle">{modalError ? "Atenção" : "Sucesso"}</h3>

            <p className="modalText">{modalError || modalSuccess}</p>

            <button
              type="button"
              className={`modalButton ${modalError ? "error" : ""}`}
              onClick={() => {
                setModalError("");
                setModalSuccess("");
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <style>
        {`
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 0;
            overflow-x: hidden;
          }

          .modalOverlay {
            position: fixed;
            inset: 0;
            z-index: 9999;
            padding: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            background:
              radial-gradient(circle at top, rgba(0, 217, 192, 0.12), transparent 35%),
              rgba(15, 23, 42, 0.62);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            animation: overlayFade 0.22s ease;
          }

          .modalBox {
            position: relative;
            width: 100%;
            max-width: 430px;
            border-radius: 30px;
            padding: 34px 28px 26px;
            overflow: hidden;
            text-align: center;
            background: #ffffff;
            border: 1px solid rgba(226, 232, 240, 0.9);
            box-shadow:
              0 30px 70px rgba(2, 8, 23, 0.24),
              0 10px 30px rgba(15, 23, 42, 0.08);
            animation: modalIn 0.26s cubic-bezier(0.2, 0.9, 0.2, 1);
          }

          /* BRILHO DECORATIVO */
          .modalBox::before {
            content: "";
            position: absolute;
            top: -70px;
            left: -40px;
            width: 180px;
            height: 180px;
            border-radius: 50%;
            background: rgba(0, 188, 212, 0.08);
          }

          .modalBox::after {
            content: "";
            position: absolute;
            right: -80px;
            bottom: -80px;
            width: 220px;
            height: 220px;
            border-radius: 50%;
            background: rgba(0, 217, 192, 0.08);
          }

          /* FECHAR */
          .modalClose {
            position: absolute;
            top: 14px;
            right: 14px;
            width: 36px;
            height: 36px;
            border: none;
            border-radius: 50%;
            background: #f1f5f9;
            color: #64748b;
            font-size: 18px;
            cursor: pointer;
            display: grid;
            place-items: center;
            transition: 0.2s ease;
          }

          .modalClose:hover {
            background: #e2e8f0;
            color: #0f172a;
            transform: rotate(90deg);
          }

          /* ÍCONE */
          .modalIcon {
            position: relative;
            z-index: 2;
            width: 82px;
            height: 82px;
            margin: 0 auto 18px;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 38px;
            font-weight: 800;
          }

          .modalIcon.success {
            color: #10b981;
            background: linear-gradient(
              135deg,
              rgba(16, 185, 129, 0.14),
              rgba(16, 185, 129, 0.08)
            );
          }

          .modalIcon.error {
            color: #ef4444;
            background: linear-gradient(
              135deg,
              rgba(239, 68, 68, 0.14),
              rgba(239, 68, 68, 0.08)
            );
          }

          .modalTitle {
            position: relative;
            z-index: 2;
            margin: 0 0 10px;
            font-size: 26px;
            font-weight: 800;
            color: #0f172a;
            letter-spacing: -0.03em;
          }

          .modalText {
            position: relative;
            z-index: 2;
            margin: 0;
            color: #64748b;
            font-size: 15px;
            line-height: 1.65;
            word-break: break-word;
          }

          .modalButton {
            position: relative;
            z-index: 2;
            margin-top: 26px;
            width: 100%;
            border: none;
            border-radius: 18px;
            padding: 15px;
            color: #fff;
            font-size: 15px;
            font-weight: 800;
            cursor: pointer;
            transition: 0.2s ease;
            background: linear-gradient(135deg, #00bcd4, #00d9c0);
            box-shadow: 0 14px 24px rgba(0, 217, 192, 0.18);
          }

          .modalButton:hover {
            transform: translateY(-2px);
          }

          .modalButton:active {
            transform: scale(0.985);
          }

          .modalButton.error {
            background: linear-gradient(135deg, #ef4444, #fb7185);
            box-shadow: 0 14px 24px rgba(239, 68, 68, 0.18);
          }

          @keyframes overlayFade {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          @keyframes modalIn {
            from {
              opacity: 0;
              transform: translateY(24px) scale(0.94);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          @media (max-width: 480px) {
            .modalBox {
              padding: 28px 20px 22px;
              border-radius: 24px;
            }

            .modalTitle {
              font-size: 22px;
            }

            .modalText {
              font-size: 14px;
            }

            .modalIcon {
              width: 72px;
              height: 72px;
              font-size: 34px;
              border-radius: 22px;
            }

            .modalButton {
              padding: 14px;
            }
          }

          .container {
            display: flex;
            justify-content: center;
            padding: 40px 15px;
            width: 100%;
          }

          .card {
            background-color: #fff;
            border-radius: 30px;
            padding: clamp(20px, 5vw, 40px);
            width: 95%;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          }

          .title {
            color: #00bcd4;
            font-size: 35px;
            margin-top: -30px;
            margin-bottom: 30px;
            font-weight: bold;
          }

          .grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 20px;
            width: 100%;
          }

          .inputGroup {
            display: flex;
            flex-direction: column;
            width: 100%;
            min-width: 0;
          }

          .label {
            color: #00bcd4;
            font-size: 14px;
            margin-bottom: 6px;
            font-weight: 600;
            min-height: 18px;
            line-height: 1.2;
          }

          .input,
          .phone-wrapper {
            width: 100%;
          }

          .input {
            border: 1px solid #00bcd4;
            border-radius: 25px;
            padding: 12px 18px;
            outline: none;
            color: #555;
            background: #fff;
            appearance: none;
          }

          .input,
          .pix-select {
            height: 44px;
            border-radius: 25px;
            display: flex;
            align-items: center;
          }

          .pix-select-wrap {
            position: relative;
            width: 100%;
          }

          .pix-select {
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
          }

          .placeholder {
            color: #aaa;
          }

          .pix-panel {
            position: absolute;
            top: calc(100% + 8px);
            left: 0;
            right: 0;
            background: #fff;
            border-radius: 16px;
            border: 1px solid rgba(0,0,0,0.08);
            box-shadow: 0 12px 25px rgba(0,0,0,0.1);
            z-index: 50;
            padding: 6px;
          }

          .pix-item {
            width: 100%;
            padding: 8px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: transparent;
            text-align: left;
            border-radius: 10px;
            cursor: pointer;
            font-weight: 600;
            color: #565556ff;
            transition: 0.2s;
          }

          .pix-item:hover {
            background: rgba(0, 217, 192, 0.1);
          }

          .pix-item.active {
            background: rgba(0, 217, 192, 0.1);
          }

          .pix-left {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .pix-select span {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .pix-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          }

          .pix-icon {
            display: flex;
            align-items: center;
            color: #00bcd4;
          }

          .input.error {
            border-color: #f00;
          }

          .phone-wrapper {
            display: flex;
            align-items: stretch;
            margin-top: 2px;
            border: 1px solid #00bcd4;
            border-radius: 25px;
            overflow: hidden;
            background: #fff;
            box-shadow: none
          }

          .ddi-box {
            display: flex;
            align-items: center;
            gap: 8px;
            border-radius: 25px;
            background: #f1f1f1;
            padding: 0 12px;
            height: 100%;
            flex-shrink: 0;
            font-size: 16px;
            color: #555;
          }

          .flag {
            width: 20px;
            height: 14px;
            object-fit: cover;
            border-radius: 2px;
          }

          .phone-input {
            flex: 1;
            border: none;
            outline: none;
            padding: 10px 15px;
            height: 44px;
            color: #555;
            background: transparent;
            min-width: 0;
          }

          .phone-input::placeholder,
          .input::placeholder {
            color: #aaa;
          }

          .passwordHint {
            font-size: 14px;
            color: #999;
            width: 90%;
            text-align: center;
            margin: 20px auto 0px;
            padding: 0 10px;
          }

          .buttonSubmit {
            background: linear-gradient(90deg, #1a7fe7, #19c4c9, #0ed079);
            color: #fff;
            border: none;
            width: 90%;
            max-width: 400px;
            padding: 16px;
            border-radius: 35px;
            margin: 30px auto 50px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            display: block;
            box-shadow: 0 5px 15px rgba(0, 217, 192, 0.1);
          }

          .buttonSubmit:hover {
            background: #0ed079ff 100%;
          }

          .buttonSubmit:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }

          .uploadSection {
            margin: -20px auto 30px;
            text-align: center;
            max-width: 600px;
            width: 85%;
            padding: 25px 15px;
            border-radius: 20px;
            background-color: #fff;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          }

          .uploadText {
            font-size: 15px;
            color: #666;
            width: 100%;
            text-align: center;
            margin: 0 auto 20px;
          }

          .uploadBox {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .uploadStatus {
            font-size: 14px;
            font-weight: bold;
            margin: 15px 0;
          }

          .buttonBlue {
            background-color: #007bff;
            color: #fff;
            border: none;
            padding: 10px 25px;
            margin-top: 10px;
            border-radius: 25px;
            cursor: pointer;
            font-weight: bold;
            width: 100%;
            max-width: 220px;
          }

          .buttonBlue:hover {
            background: #0ed079ff 100%;
          }

          .scan-container {
            position: relative;
            width: 90px;
            height: 90px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
            background: #fff;
          }

          .scan-container:not(.has-image) {
            overflow: visible;
          }

          .scan-container.has-image {
            overflow: hidden;
            border-radius: 50%;
          }

          .scan-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
            display: block;
          }

          .corner {
            position: absolute;
            width: 20px;
            height: 20px;
            z-index: 3;
          }

          .top-left {
            top: 0; left: 0;
            border-top: 5px solid #00A7CF;
            border-left: 5px solid #00A7CF;
            border-top-left-radius: 12px;
          }

          .top-right {
            top: 0; right: 0;
            border-top: 5px solid #00A7CF;
            border-right: 5px solid #00A7CF;
            border-top-right-radius: 12px;
          }

          .bottom-left {
            bottom: 0; left: 0;
            border-bottom: 5px solid #00A7CF;
            border-left: 5px solid #00A7CF;
            border-bottom-left-radius: 12px;
          }

          .bottom-right {
            bottom: 0; right: 0;
            border-bottom: 5px solid #00D9C0;
            border-right: 5px solid #00D9C0;
            border-bottom-right-radius: 12px;
          }

          .hidden-file-input {
            display: none;
          }

          .messageBox {
            width: 90%;
            max-width: 700px;
            margin: 0 auto 20px;
            padding: 14px 18px;
            border-radius: 14px;
            font-weight: 600;
          }

          .messageError {
            background: #ffe5e5;
            color: #b00020;
            border: 1px solid #ffb3b3;
          }

          .messageSuccess {
            background: #e8fff4;
            color: #0f7a44;
            border: 1px solid #b7f0d1;
          }

          @media (max-width: 768px) {
            .title {
              text-align: center;
              margin-top: -10px;
            }

            .card {
              border-radius: 20px;
            }
          }

          @media (min-width: 769px) {
            .grid {
              grid-template-columns: repeat(3, 1fr);
            }

            .uploadBox {
              flex-direction: row;
              justify-content: center;
            }

            .scan-container {
              margin-left: 100px;
            }

            .identification-file-container {
              margin-left: -30px;
            }
          }

          @media (min-width: 981px) and (max-width: 1199px) {
            .card { width: 900px; }
          }

          @media (min-width: 1200px) and (max-width: 1439px) {
            .card { width: 1000px; }
          }

          @media (min-width: 1440px) {
            .card { width: 1150px; }
          }
        `}
      </style>

      <div className="container">
        <div className="card">
          <h2 className="title">
            <svg
              width="42"
              height="42"
              viewBox="0 0 24 24"
              fill="none"
              stroke="url(#meuGradiente)"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ position: "relative", top: 10, left: 10 }}
            >
              <defs>
                <linearGradient
                  id="meuGradiente"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop offset="0%" stopColor="#19c4c9" />
                  <stop offset="100%" stopColor="#19c4c9" />
                </linearGradient>
              </defs>
              <path d="M5 17l5-5-5-5" />
              <path d="M13 17l5-5-5-5" />
            </svg>{" "}
            Cadastro
          </h2>

          {modalError ? (
            <div className="messageBox messageError">{modalError}</div>
          ) : null}

          {modalSuccess ? (
            <div className="messageBox messageSuccess">{modalSuccess}</div>
          ) : null}

          <div className="grid">
            <div className="inputGroup">
              <label className="label">Nome</label>
              <input
                className={`input ${fieldErrors.nome ? "error" : ""}`}
                value={form.nome}
                onChange={(e) => handleChange("nome", e.target.value)}
                onBlur={() => validateField("nome")}
              />
              {fieldErrors.nome ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.nome}
                </small>
              ) : null}
            </div>

            <div className="inputGroup">
              <label className="label">Email</label>
              <input
                className={`input ${fieldErrors.email ? "error" : ""}`}
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
                onBlur={() => validateField("email")}
              />
              {fieldErrors.email ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.email}
                </small>
              ) : null}
            </div>

            <div className="inputGroup">
              <label className="label">Data de nascimento</label>
              <input
                className={`input ${fieldErrors.data_nascimento ? "error" : ""}`}
                placeholder="DD/MM/AAAA"
                value={form.data_nascimento}
                onChange={(e) => handleDateChange(e.target.value)}
                onBlur={() => validateField("data_nascimento")}
              />
              {fieldErrors.data_nascimento ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.data_nascimento}
                </small>
              ) : null}
            </div>

            <div className="inputGroup">
              <label className="label">Telefone com Whatsapp</label>
              <div className="phone-wrapper">
                <div className="ddi-box">
                  <img
                    src="https://flagcdn.com/w40/br.png"
                    alt="Brasil"
                    className="flag"
                  />
                  <span>+55</span>
                </div>

                <input
                  type="tel"
                  className="phone-input"
                  value={form.telefone}
                  onChange={(e) => handlePhoneChange(e.target.value)}
                  onBlur={() => validateField("telefone")}
                />
              </div>
              {fieldErrors.telefone ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.telefone}
                </small>
              ) : null}
            </div>

            <div className="inputGroup">
              <label className="label">CPF</label>
              <input
                className={`input ${fieldErrors.cpf ? "error" : ""}`}
                value={form.cpf}
                onChange={(e) => handleCpfChange(e.target.value)}
                onBlur={() => validateField("cpf")}
                maxLength={14}
                placeholder="000.000.000-00"
              />
              {fieldErrors.cpf ? (
                <small style={{ color: "#F00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.cpf}
                </small>
              ) : null}
            </div>

            <div className="inputGroup">
              <label className="label">Tipo de chave pix</label>
              <div className="pix-select-wrap" ref={pixRef}>
                <button
                  type="button"
                  className={`input pix-select ${fieldErrors.tipo_pix ? "error" : ""}`}
                  onClick={() => setOpenPix((prev) => !prev)}
                >
                  <div className="pix-left">
                    {form.tipo_pix ? (
                      <>
                        {
                          tiposPix.find((item) => item.label === form.tipo_pix)
                            ?.icon
                        }
                        <span>{form.tipo_pix}</span>
                      </>
                    ) : (
                      <span className="placeholder">Selecione o tipo</span>
                    )}
                  </div>

                  <ExpandMore style={{ color: "#11b9a3", fontSize: 20 }} />
                </button>

                {openPix && (
                  <div className="pix-panel">
                    {tiposPix.map((item) => (
                      <button
                        key={item.label}
                        type="button"
                        className={`pix-item ${
                          form.tipo_pix === item.label ? "active" : ""
                        }`}
                        onClick={() => {
                          handleChange("tipo_pix", item.label);
                          setOpenPix(false);
                        }}
                      >
                        <button
                          key={item.label}
                          type="button"
                          className={`pix-item ${
                            form.tipo_pix === item.label ? "active" : ""
                          }`}
                          onClick={() => {
                            handleChange("tipo_pix", item.label);
                            setOpenPix(false);
                          }}
                        >
                          <div className="pix-row">
                            <span>{item.label}</span>
                            <span className="pix-icon">{item.icon}</span>
                          </div>
                        </button>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              {fieldErrors.tipo_pix ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.tipo_pix}
                </small>
              ) : null}
            </div>

            <div
              className="inputGroup"
              style={{
                gridColumn: isSocialCadastro ? "1 / -1" : "auto",
              }}
            >
              <label className="label">Chave PIX</label>
              <input
                className={`input ${fieldErrors.chave_pix ? "error" : ""}`}
                value={form.chave_pix}
                onChange={(e) => handleChange("chave_pix", e.target.value)}
                onBlur={() => validateField("chave_pix")}
              />
              {fieldErrors.chave_pix ? (
                <small style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}>
                  {fieldErrors.chave_pix}
                </small>
              ) : null}
            </div>

            {!isSocialCadastro && (
              <>
                <div className="inputGroup">
                  <label className="label">Senha</label>
                  <input
                    type="password"
                    className={`input ${fieldErrors.senha ? "error" : ""}`}
                    value={form.senha}
                    onChange={(e) => handleChange("senha", e.target.value)}
                    onBlur={() => validateField("senha")}
                  />
                  {fieldErrors.senha ? (
                    <small
                      style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}
                    >
                      {fieldErrors.senha}
                    </small>
                  ) : null}
                </div>

                <div className="inputGroup">
                  <label className="label">Repetir senha</label>
                  <input
                    type="password"
                    className={`input ${fieldErrors.repetir_senha ? "error" : ""}`}
                    value={form.repetir_senha}
                    onChange={(e) =>
                      handleChange("repetir_senha", e.target.value)
                    }
                    onBlur={() => validateField("repetir_senha")}
                  />
                  {fieldErrors.repetir_senha ? (
                    <small
                      style={{ color: "#f00", marginLeft: 10, marginTop: 5 }}
                    >
                      {fieldErrors.repetir_senha}
                    </small>
                  ) : null}
                </div>
              </>
            )}
          </div>

          {!isSocialCadastro && (
            <p className="passwordHint">
              As senhas devem conter 8 caracteres, 1 letra maiúscula, 1
              minúscula e um símbolo.
            </p>
          )}
        </div>
      </div>

      <div className="uploadSection">
        <p className="uploadText">
          Para continuar seu cadastro precisamos que nos envie uma foto de
          identificação
        </p>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden-file-input"
          onChange={handleFileChange}
        />

        <div className="uploadBox">
          <div className={`scan-container ${filePreview ? "has-image" : ""}`}>
            {!filePreview && (
              <>
                <div className="corner top-left"></div>
                <div className="corner top-right"></div>
                <div className="corner bottom-left"></div>
                <div className="corner bottom-right"></div>
              </>
            )}

            {filePreview ? (
              <img src={filePreview} alt="preview" className="scan-image" />
            ) : (
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                <defs>
                  <linearGradient
                    id="iconGrad"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#007BFF" />
                    <stop offset="100%" stopColor="#00D9C0" />
                  </linearGradient>
                </defs>
                <path
                  d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                  fill="url(#iconGrad)"
                />
              </svg>
            )}
          </div>

          <div className="identification-file-container">
            <span className="uploadStatus">
              {fileName
                ? "identificação adicionada"
                : "Sem arquivo de identificação"}
            </span>

            <button
              type="button"
              className="buttonBlue"
              onClick={openFilePicker}
            >
              Escolher arquivo
            </button>
          </div>
        </div>
      </div>

      <button
        className="buttonSubmit"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "SALVANDO..." : "CONTINUAR"}
      </button>

      <br />
    </>
  );
}
